import * as ReactDOM from 'react-dom/client';

import { App } from './app/App';
import { postHogService } from './app/application/PostHogService';
import { intercom } from './app/services/intercom';

// -- START -- Services initialization
postHogService.init();

if (!intercom.booted()) {
  intercom.boot();
}
// -- END -- Services initialization

const root = ReactDOM.createRoot(document.getElementById(`root`) as HTMLElement);

root.render(
  // <StrictMode>
  <App />
  // </StrictMode>
);
